import React, { useRef, useEffect, useCallback } from "react";

import MapContainer from "../../common/CustomGoogleMap/MapContainer";
import { Box, Card, Grid, Typography } from "@material-ui/core";
import { MapPolygonInterface, PlolygonServicesInitialStateInteface, mapOptionStyles } from "../Utils/PlolygonServicesInterface";
import { CoordinatesInterface } from "../../../config/constants";
import { isArrayValid, isEmptyOrNull, isUndefined } from "../../../utils/DataUtils";

interface PolygonMapServiceInterface {
  classes: any;
  appStateObj: PlolygonServicesInitialStateInteface;
  fetchPolygonServiceMapRecordnBasedOnBoundaries: (northEast: CoordinatesInterface, southWest: CoordinatesInterface) => void;
  openPolygonPosZoneInfoWindow: (markerIndex: number) => void;
  handlePolygonClick: (event: any, polygon: MapPolygonInterface) => void;
  posZoneMarkerInfoWindow: any;
}

const PolygonMapService = (props: PolygonMapServiceInterface) => {
  const { classes, appStateObj, fetchPolygonServiceMapRecordnBasedOnBoundaries, openPolygonPosZoneInfoWindow, handlePolygonClick, posZoneMarkerInfoWindow } = props;
  const refMap = useRef() as any;
  const debounceTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  // Cleanup debounce timeout on unmount to prevent memory leaks
  useEffect(() => {
    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
  }, []);

  const onIdle = useCallback(() => {
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    debounceTimeoutRef.current = setTimeout(() => {
      if (!isEmptyOrNull(refMap?.current)) {
        const bounds = refMap.current.getBounds();
        if (bounds) {
          const ne = bounds.getNorthEast();
          const sw = bounds.getSouthWest();
          const northEastCord: CoordinatesInterface = { lat: Number(ne.lat()), lng: Number(ne.lng()) };
          const southWestCord: CoordinatesInterface = { lat: Number(sw.lat()), lng: Number(sw.lng()) };
          fetchPolygonServiceMapRecordnBasedOnBoundaries(northEastCord, southWestCord);
        }
      }
    }, 500);
  }, [fetchPolygonServiceMapRecordnBasedOnBoundaries]);

  return (
    <>
      <Grid container className={classes.colorSchemeGridContainerStyle}>
        {!isUndefined(appStateObj?.serviceBasedColorRecord) &&
          isArrayValid(appStateObj?.serviceBasedColorRecord) &&
          appStateObj.serviceBasedColorRecord.map((serviceObj: any, serviceObjIndex: number) => (
            <Grid item className={classes.colorSchemeGridItemStyle} key={`${serviceObjIndex}-${serviceObj?.displayName ?? serviceObj.name ?? ""}`}>
              <Box style={{ backgroundColor: serviceObj.strokeColor }} className={classes.colorSchemeBoxStyle}></Box>
              <Typography className={classes.colorSchemeSpanStyle}>{`${serviceObj.displayName ?? serviceObj.name ?? ""}`}</Typography>
            </Grid>
          ))}
      </Grid>
      <Card className={classes.mapContainerCardStyle}>
        <div className={classes.mapContainerDiv}>
          <MapContainer
            refMap={refMap}
            center={appStateObj.mapCenter}
            zoom={appStateObj.mapZoom}
            onIdle={onIdle}
            markers={appStateObj.mapMarkersRecord}
            polygons={appStateObj.mapPolygonsRecord}
            handlePolygonClick={handlePolygonClick}
            posZoneMarkerInfoWindow={posZoneMarkerInfoWindow}
            openPolygonPosZoneInfoWindow={openPolygonPosZoneInfoWindow}
            mapOptionStyles={mapOptionStyles}
          />
        </div>
      </Card>
    </>
  );
};

export default React.memo(PolygonMapService);
